export default function ImpactsSection() {
  return (
    <section className="bg-[#FAF7F4] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Titre de section */}
        <h2 className="text-4xl md:text-5xl text-center text-[#3D2817] mb-20" style={{ fontFamily: 'Playfair Display, serif' }}>
          (Les impacts sur votre équitation)
        </h2>

        {/* Grille de 3 cartes */}
        <div className="grid md:grid-cols-3 gap-10">
          {/* Carte 1 - Douleurs Physiques avec Image */}
          <div className="relative rounded-3xl overflow-hidden min-h-[400px]">
            <img 
              src="https://static.readdy.ai/image/972e8dcf8005bdff37194c729f906789/8600f8774b87e45ae578a4bb3e9989d7.jpeg"
              alt="Douleurs physiques en équitation"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
            
            <div className="absolute top-6 left-6 bg-black/60 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2">
              <i className="ri-heart-pulse-line text-white"></i>
              <span className="text-white text-sm font-medium">Douleurs</span>
            </div>
            
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">Douleurs Physiques</h3>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-white/90 text-sm">
                  <span className="text-[#E8956F] mt-1">•</span>
                  <span>Douleurs pelviennes intenses</span>
                </li>
                <li className="flex items-start gap-2 text-white/90 text-sm">
                  <span className="text-[#E8956F] mt-1">•</span>
                  <span>Lombaires sollicitées</span>
                </li>
                <li className="flex items-start gap-2 text-white/90 text-sm">
                  <span className="text-[#E8956F] mt-1">•</span>
                  <span>Irradiations dans les jambes</span>
                </li>
                <li className="flex items-start gap-2 text-white/90 text-sm">
                  <span className="text-[#E8956F] mt-1">•</span>
                  <span>Fatigue chronique</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Carte 2 - Impact sur la Pratique */}
          <div className="relative rounded-3xl overflow-hidden min-h-[400px]">
            <img 
              src="https://static.readdy.ai/image/972e8dcf8005bdff37194c729f906789/e42ff8fea2c3c377fdbf68df8974ba94.jpeg"
              alt="Impact sur la performance"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
            
            <div className="absolute top-6 left-6 bg-black/60 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2">
              <i className="ri-speed-line text-white"></i>
              <span className="text-white text-sm font-medium">Performance</span>
            </div>
            
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-3xl font-bold text-white leading-tight">
                Votre potentiel réel est amputé
              </h3>
            </div>
          </div>

          {/* Carte 3 - Relation Cheval avec Image */}
          <div className="relative rounded-3xl overflow-hidden min-h-[400px]">
            <img 
              src="https://static.readdy.ai/image/972e8dcf8005bdff37194c729f906789/70ca951c3d2c6f8d6f74f5764ba596a1.jpeg"
              alt="Relation cavalière-cheval"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
            
            <div className="absolute top-6 left-6 bg-black/60 backdrop-blur-sm px-4 py-2 rounded-full flex items-center gap-2">
              <i className="ri-heart-line text-white"></i>
              <span className="text-white text-sm font-medium">Connexion</span>
            </div>
            
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">Relation avec le Cheval</h3>
              <p className="text-white/90 text-sm leading-relaxed mb-3">
                Le cheval perçoit instantanément les tensions, les crispations et l'état émotionnel de la cavalière.
              </p>
              <p className="text-white/90 text-sm leading-relaxed">
                Lorsque la douleur est présente, le corps se rigidifie et la communication devient moins claire.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
